import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import {
    formationsFetchData,
    playersFetchData,
    createTeamForSelectedFormation,
    setTutorialCookie,
    openMobilePlayerListing,
    triggerHandleFixturePopup,
    fetchPlayerRecomendation,
    setPlayerRecomendationFirstTimeFalse,
    showHidePlayerRecomendationPopUp,
    showHidePlayerRecomendationPopUpMob
} from './../../actions/FormationActions';
import {
    resetFilter,
    resetAllFilters,
} from './../../actions/FilterActions';


import { withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import ProgressBar from './ProgressBar';
import Heading from './Heading';
import MobileBudget from './MobileBudget';
import MainPitch from './MainPitch';
import FormationPopup from './FormationPopup';
import Modal from './../Modal';
import PlayerCard from './../playerCard';
import ErrorModal from './../GenericMessage';
import UpcomingFixturesPopup from './../matches/upcomingFixturesPopup';
import config from './../../config';
import common from './../../common';
import Matches from "../matches";


class CreateTeam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animEnded: false
        };
        this.timeout = null;
        this.interval = null;
        this.isFormationLoaded = false;
        this.hasSeenAnimation = false;
    }

    componentWillMount() {
        const COOKIE_GM = config.COOKIE_GM;
        let cookie = common.getCookie(COOKIE_GM);
        if (cookie) {
            if (common.parseCookie(cookie).HasTeam == 0 && common.isEndOfSeason(this.props.constraints.GamercardSubScenario)) {
                // window.location.href = config.BASE_DIR + "/end-of-season";
                return this.props.history.push('/end-of-season');
            }
        } else {
            if (common.isEndOfSeason(this.props.constraints.GamercardSubScenario)) {
                // window.location.href = config.BASE_DIR + "/end-of-season"
                return this.props.history.push('/end-of-season');
            }
        }

        if (sessionStorage.getItem('hasSeenAnimation')) {
            this.hasSeenAnimation = true;
        } else {
            sessionStorage.setItem('hasSeenAnimation', true);
        }
        const formationPromise = this.props.fetchFormations(this.props.constraints.GamedayId);
        const playersPromise = this.props.fetchPlayers(this.props.constraints.GamedayId);
        Promise.all([formationPromise, playersPromise]).then(() => {
            const oldFormationId = this.props.defaultFormationIndex;
            this.props.setDefaultFormation(this.props.constraints, undefined, oldFormationId);
            this.isFormationLoaded = true;
            if (this.props.callPlayerRecomendation) {
                //call platyer recomendation player
                this.props.fetchPlayerRecomendation()
            }
        }).catch(reason => {
        });
    }

    detectAnimationEnd = (cb) => {
        let count = 0;
        let globalCount = 0;
        let element = $('.si-main-component');
        element.on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', () => {
            ++count;
            clearInterval(this.interval);
            this.interval = setInterval(() => {
                if (globalCount === count) {
                    this.setState({ animEnded: true });
                    clearInterval(this.interval);
                    typeof cb === 'function' && cb();
                } else {
                    globalCount = count;
                }
            }, 250);
        });
    };

    componentDidMount() {
        this.props.resetAllFilters();
        this.detectAnimationEnd(() => {
            if (this.isFormationLoaded) {
                if (!this.props.hasSeenTutorial && config.isMobile) {
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.props.setTutorialCookie();
                    }, 3000);
                }
            }
        });

        let cookie = common.getCookie(config.COOKIE_GM);
        let cookieGM = common.parseCookie(cookie);
    }

    componentWillUnmount() {
        this.props.triggerHandleFixturePopup(false);
        clearTimeout(this.timeout);
        clearInterval(this.interval);
    }

    handleNext = () => {
        if (this.props.captainID) {
            // return this.props.history.push('/select-badge');
            return this.props.history.push('/team-name');
        } else {
            return this.props.history.push('/select-captain');
        }
    };


    render() {
        const { trans, location, budget, playerCount, hasSeenTutorial, mobilePlayerListingOpen, mobileFilterOpen, commonError, isPlayerCardVisible, isFixturePopupVisible, teamError, isGamingHubLoaded } = this.props;
        const animEnded = this.state.animEnded || this.hasSeenAnimation || false;
        let showOverlay = !hasSeenTutorial || mobileFilterOpen;
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-budget-anim': !animEnded,
            'si-no-anim': animEnded,
            'si-filter-slideIn': mobilePlayerListingOpen,
            'si-slide-up': mobileFilterOpen,
        });
        const isDisabled = (playerCount < config.MAX_PLAYERS_PER_TEAM) || (budget < 0);
        let genericMessage = null;


        if (commonError === 'autoFillError') genericMessage = trans['autoFillError'];
        return (
            <React.Fragment>
                <div className={ wrapperClass }>
                    <div className="si-container">
                        <div className="si-top-section si-mob">
                            <ProgressBar />
                            <Heading title={ trans['pick_your_players'] } { ...{ isDisabled } }
                                text={ trans.next }
                                showTitle={ isDisabled } tooltipText={ trans['select_your_team'] }
                                handler={ () => this.handleNext() } />
                            <MobileBudget />
                        </div>
                        <MainPitch toShowList={ getStep(location.pathname) === 0 } showPlayerRecomendationPopUp={ this.props.showPlayerRecomendationPopUp } showHidePlayerRecomendationPopUp={ this.props.showHidePlayerRecomendationPopUp } setPlayerRecomendationFirstTimeFalse={ this.props.setPlayerRecomendationFirstTimeFalse } showPlayerrecomendationPopupMobile={ this.props.showPlayerrecomendationPopupMobile } showHidePlayerRecomendationPopUpMob={ this.props.showHidePlayerRecomendationPopUpMob } { ...{ isDisabled } } />

                        <FormationPopup />
                        { isPlayerCardVisible && !this.props.overview ? <PlayerCard /> : null }
                        { isFixturePopupVisible ? <UpcomingFixturesPopup /> : null }
                        <Modal error={ teamError } showOverlay={ showOverlay } />
                        <ErrorModal error={ genericMessage } icon={ "icon-ucl-euro" } />
                    </div>
                </div>
                {
                    (!config.isMobile)
                        ?
                        <Matches { ...this.props } />
                        :
                        null
                }
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchFormations: (GamedayId) => dispatch(formationsFetchData(GamedayId)),
        fetchPlayers: (GamedayId) => dispatch(playersFetchData(GamedayId)),
        setDefaultFormation: (constraints, oldFormationId, newFormationId) => dispatch(createTeamForSelectedFormation(constraints, oldFormationId, newFormationId)),
        setTutorialCookie: () => dispatch(setTutorialCookie()),
        openMobilePlayerListing: (bool) => dispatch(openMobilePlayerListing(bool)),
        resetFilter: () => dispatch(resetFilter()),
        resetAllFilters: () => dispatch(resetAllFilters()),
        triggerHandleFixturePopup: (isFixturePopupVisible) => dispatch(triggerHandleFixturePopup(isFixturePopupVisible)),
        fetchPlayerRecomendation: () => dispatch(fetchPlayerRecomendation()),
        setPlayerRecomendationFirstTimeFalse: () => dispatch(setPlayerRecomendationFirstTimeFalse()),
        showHidePlayerRecomendationPopUp: (bool) => dispatch(showHidePlayerRecomendationPopUp(bool)),
        showHidePlayerRecomendationPopUpMob: (bool) => dispatch(showHidePlayerRecomendationPopUpMob(bool))
    };
};
const mapStateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        defaultFormationIndex: state.formationData.defaultFormationIndex,
        trans: state.appData.trans,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        hasSeenTutorial: state.formationData.hasSeenTutorial,
        budget: state.formationData.teamData.budget,
        playerCount: state.formationData.teamData.playerCount,
        captainID: state.formationData.teamData.captainID,
        teamError: state.formationData.teamError,
        commonError: state.formationData.commonError,
        mobileFilterOpen: state.formationData.mobileFilterOpen,
        formations: state.formationData.formations,
        isPlayerCardVisible: state.formationData.isPlayerCardVisible,
        isFixturePopupVisible: state.formationData.isFixturePopupVisible,
        callPlayerRecomendation: state.formationData.playerRecomendation,
        showPlayerRecomendationPopUp: state.formationData.showPlayerRecomendationPopUp,
        showPlayerrecomendationPopupMobile: state.formationData.showPlayerrecomendationPopupMobile,
        isGamingHubLoaded: state.authData.isGamingHubLoaded,
        overview: state.formationData.overview,
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateTeam));


// WEBPACK FOOTER //
// ./src/components/onboarding/CreateTeam.js